export const getPaintingExample = (value: string) => {
  switch (value) {
    case 'ORANGE_WITH_BLUE':
      return {
        desktop: '/images/product/drawer/pomarancz-niebieski_desktop.png',
        mobile: '/images/product/drawer/pomarancz-niebieski_mobile.png',
      }
    case 'ORANGE_WITH_PINK':
      return {
        desktop: '/images/product/drawer/pomarancz-roz_jasny_desktop.png',
        mobile: '/images/product/drawer/pomarancz-roz_jasny_mobile.png',
      }
    case 'RED_WITH_BLUE':
      return {
        desktop: '/images/product/drawer/czerwony-blekit_desktop.png',
        mobile: '/images/product/drawer/czerwony-blekit_mobile.png',
      }
    case 'RED_WITH_GOLD':
      return {
        desktop: '/images/product/drawer/czerwony-zloto_desktop.png',
        mobile: '/images/product/drawer/czerwony-zloto_mobile.png',
      }
    case 'TURQUOISE_WITH_YELLOW':
      return {
        desktop: '/images/product/drawer/zielony-zolty_desktop.png',
        mobile: '/images/product/drawer/zielony-zolty_mobile.png',
      }
    case 'ROSE_WTH_SKY_BLUE':
      return {
        desktop: '/images/product/drawer/roz-niebieski_desktop.png',
        mobile: '/images/product/drawer/roz-niebieski_mobile.png',
      }
    case 'SKY_BLUE_WITH_GOLD':
      return {
        desktop: '/images/product/drawer/niebieski-zloto_desktop.png',
        mobile: '/images/product/drawer/niebieski-zloto_mobile.png',
      }
    case 'ROSE_WITH_GOLD':
      return {
        desktop: '/images/product/drawer/roz-zolty_desktop.png',
        mobile: '/images/product/drawer/roz-zolty_mobile.png',
      }
    case 'BLUE_WITH_ROSE':
      return {
        desktop: '/images/product/drawer/blekit-roz_desktop.png',
        mobile: '/images/product/drawer/blekit-roz_mobile.png',
      }
    case 'ROSE_WITH_WHITE':
      return {
        desktop: '/images/product/drawer/roz-bialy_desktop.png',
        mobile: '/images/product/drawer/roz-bialy_mobile.png',
      }
    case 'ROSE_WITH_RED':
      return {
        desktop: '/images/product/drawer/roz-czerwony_desktop.png',
        mobile: '/images/product/drawer/roz-czerwony_mobile.png',
      }
    case 'YELLOW_WITH_WHITE':
      return {
        desktop: '/images/product/drawer/zolty-bialy_desktop.png',
        mobile: '/images/product/drawer/zolty-bialy_mobile.png',
      }
    case 'BLUE':
      return {
        desktop: '/images/product/drawer/blekit_desktop.png',
        mobile: '/images/product/drawer/blekit_mobile.png',
      }
    case 'GOLD':
      return {
        desktop: '/images/product/drawer/zloty_desktop.png',
        mobile: '/images/product/drawer/zloty_mobile.png',
      }
    case 'SILVER':
      return {
        desktop: '/images/product/drawer/srebro_desktop.png',
        mobile: '/images/product/drawer/srebro_mobile.png',
      }
    case 'BLACK':
      return {
        desktop: '/images/product/drawer/czarny_desktop.png',
        mobile: '/images/product/drawer/czarny_mobile.png',
      }
    default:
      return {
        desktop: '/images/product/drawer/zloty_desktop.png',
        mobile: '/images/product/drawer/zloty_mobile.png',
      }
  }
}
